
export default defineNuxtPlugin((nuxtApp) => {
  const { VERCEL_DEPLOYMENT_ID } = nuxtApp.$config.public

  const {
    reloadToLatestDeployment,
    clearDeploymentIdCookie,
  } = useSkewProtection()

  // Try to remove the deployment ID cookie on browser reload to get the latest deployment
  window.addEventListener('beforeunload', clearDeploymentIdCookie)

  // Set __vdpl cookie to VERCEL_DEPLOYMENT_ID on tab focus to keep track of which deployment the user is on
  window.addEventListener('focus', () => {
    if (VERCEL_DEPLOYMENT_ID) {
      document.cookie = `__vdpl=${VERCEL_DEPLOYMENT_ID}; path=/_nuxt; max-age=${60 * 60 * 24 * 30}; SameSite=Lax${process.env.NODE_ENV === 'production' ? '; Secure' : ''};`
    }
  })

  // Global handler for chunk loading errors (e.g., 403 Forbidden)
  window.addEventListener('error', (event) => {
    // Only handle errors from script tags (chunk loading)
    const target = event.target as HTMLElement | null
    if (target && target.tagName === 'SCRIPT') {
      // Optionally, check if the src matches your chunk naming pattern
      const src = (target as HTMLScriptElement).src
      if (src && /\.(js|mjs)(\?.*)?$/.test(src)) {
        console.info('Global script error detected', src)
      }
    }
  }, true)

  // Reload on chunkError
  nuxtApp.hook('app:chunkError', (e) => {
    console.info('ChunkError reload', e)

    try {
      reloadToLatestDeployment()
    } catch {
      //
    }
  })
})
